import CopyToClipboard from '@montugroup/circuit-shared/components/common/CopyToClipboard';
import { Stack, Typography } from '@montugroup/design-system';
import { useTheme } from '@mui/material';
import { DateTime } from 'luxon';

const PrescriptionDetailsRow = ({ title, value, copyable }: { title: string; value: string; copyable?: boolean }) => {
  return (
    <Stack direction={'row'} gap={1} padding={4} justifyContent={'space-between'}>
      <Stack direction={'column'}>
        <Typography variant="body2">{title}</Typography>
        <Typography variant="body2" fontWeight={'600'}>
          {value}
        </Typography>
      </Stack>
      {copyable && <CopyToClipboard textToCopy={value} buttonVariant="icon" size="small" />}
    </Stack>
  );
};

interface PrescriptionDetailsProps {
  token?: string;
  dosageInstructions?: string | null;
  prescribedDate?: string;
  patientInitials?: string | null;
}

export function PrescriptionDetails({
  token,
  dosageInstructions,
  prescribedDate,
  patientInitials,
}: PrescriptionDetailsProps) {
  const { palette } = useTheme();

  return (
    <Stack
      direction={'column'}
      sx={{
        border: '1px solid ', // outer group border
        borderColor: palette.action.disabled,
        borderRadius: 2,
        overflow: 'hidden', // ensures children respect rounded corners

        '& > *:not(:last-of-type)': {
          borderBottom: '1px solid', // internal dividers
          borderColor: palette.divider,
        },
      }}
    >
      {patientInitials && <PrescriptionDetailsRow title={'Patient Initials'} value={patientInitials} />}
      {token && <PrescriptionDetailsRow title={'Script Token'} value={token} copyable />}
      {dosageInstructions && <PrescriptionDetailsRow title={'Dose Instructions'} value={dosageInstructions} />}
      {prescribedDate && (
        <PrescriptionDetailsRow
          title={'Prescribed Date'}
          value={DateTime.fromISO(prescribedDate, { zone: 'utc' }).toFormat('dd/LL/yyyy')}
        />
      )}
    </Stack>
  );
}
